import type { ReduxState } from './druid/types/internal/ReduxState';

export default ({ sendTimeout }: ReduxState): number => sendTimeout;
